import { render, staticRenderFns } from "./ResetSaasPlans.vue?vue&type=template&id=f2d265ea&"
import script from "./ResetSaasPlans.vue?vue&type=script&lang=js&"
export * from "./ResetSaasPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports